import { Entity } from "../helpers/Entity"

export type AccountLimitAttributesDto = {
    accountId: string
    documentLimit: number
    documentUsage: number
    cutOffDay: number
    periodStart: string
    periodEnd: string
    nextPeriodStart: string
    isLimitEnforced: boolean
}

export type AccountLimitDto = {
    id: string
    type: string
    attributes: AccountLimitAttributesDto
}

export default class AccountLimit implements Entity {
    private dto: AccountLimitDto

    constructor(dto: AccountLimitDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.dto.id != "" && this.dto.type == "account-limits"
    }

    getId(): string {
        return this.dto.id
    }

    getDto(): AccountLimitDto {
        return this.dto
    }


}




// WEBPACK FOOTER //
// ./src/state/account-limit/AccountLimit.ts